module.exports = __webpack_public_path__ + "static/media/cardKsusp.56aced16.svg";